document.addEventListener("alpine:init", () => {
    Alpine.data("ProductCustomMain", (variantId) => ({
        currentProduct: JSON.parse(
            document.getElementById("product-lens-json-data").textContent,
        ),
        selectedVariant: undefined,
        variantImages: [],
        variantHightLightImages: [],
        active: 0,
        startX: 0,
        currentX: 0,
        dragging: false,
        translateX: 0,
        mobileSize: 999,
        isDesktop: window.innerWidth > 999,
        isLoading: false,
        selectedImage: undefined,
openExpandImage: false,
variantImageCache: {},
variantPreloadStarted: {},
formatPrice(price) {
            return new Intl.NumberFormat("pt-BR", {
                style: "currency",
                currency: "BRL",
            }).format(price / 100);
        },
        changeVariant(changeId) {
            this.selectedVariant = Alpine.raw(
                this.currentProduct.variants,
            ).find((x) => x.id === changeId);

            this.updateAuglioVariant();

            const url = new URL(window.location.href);

            url.searchParams.set("variant", this.selectedVariant.id);

            window.history.replaceState({}, "", url.toString());

            this.active = 0;
            this.translateX = 0;
            this.dragging = false;
            
            this.loadVariableImages(false);
            // this.visibleImages();
                },

        updateAuglioVariant() {
            if (!this.selectedVariant || !this.selectedVariant.id) return;

            const variantId = this.selectedVariant.id;

            const auglioButtons = document.querySelectorAll(
                '.auglio-tryon-btn-product-page, .auglio-tryon-btn'
            );

            auglioButtons.forEach((btn) => {
                btn.setAttribute('data-item_id', variantId);
                btn.dataset.item_id = variantId;

                // Mantém compatibilidade caso o app leia outros nomes de atributo
                btn.setAttribute('data-variant-id', variantId);
                btn.setAttribute('data-variant_id', variantId);
            });
        },

        get visibleImages() {
            if (this.isDesktop) {
                return this.variantImages.slice(4);
            }
            return this.variantImages;
        },
        get itemWidth() {
            return this.$refs.carousel.clientWidth / (this.isDesktop ? 3 : 4);
        },
        maxIndex() {
            const visibleCount = this.isDesktop ? 3 : 5;
            return Math.max(this.visibleImages.length - visibleCount, 0);
        },
        updatePosition() {
            this.translateX = -this.active * this.itemWidth;
        },
        clearString(text) {
            return text.replace(/[^a-zA-Z0-9]/g, "");
        },
        start(x) {
            this.dragging = true;
            this.startX = x;
            this.currentX = x;
        },
        move(x) {
             if (!this.dragging) return;

    this.currentX = x;

    const delta = x - this.startX;
    const nextTranslate = -this.active * this.itemWidth + delta;

    const maxTranslate = 0;
    const minTranslate = -this.maxIndex() * this.itemWidth;

    this.translateX = Math.min(maxTranslate, Math.max(minTranslate, nextTranslate));

        },
        end() {
            if (!this.dragging) return;
            this.dragging = false;

            const delta = this.currentX - this.startX;
            const threshold = this.itemWidth * 0.3;

            if (Math.abs(delta) > threshold) {
        const steps = Math.max(1, Math.round(Math.abs(delta) / this.itemWidth));

        if (delta > 0) {
            this.active = Math.max(this.active - steps, 0);
        } else {
            this.active = Math.min(this.active + steps, this.maxIndex());
        }

        this.updatePosition();
    } else {
        this.updatePosition();
    }
        },
        prev() {
            if (this.active > 0) {
                this.active--;
            }
            this.updatePosition();
        },
        next() {
            if (this.active < this.maxIndex()) {
                this.active++;
            }
            this.updatePosition();
        },
        returnSrcSet(src) {
    let srcset = "";

    const sizes = this.isDesktop
        ? [500, 700, 900, 1100, 1300, 1500]
        : [240, 320, 420, 600, 750, 900];

    sizes.forEach((size) => {
        srcset += `${src}&width=${size} ${size}w, `;
    });

    return srcset.trim().slice(0, -1);
},
       handleLoading() {
    this.isLoading = false;
},

updateMobileSelectedImage(image) {
    if (this.isDesktop || !image || !image.src) return;

    this.$nextTick(() => {
        const imageEl = this.$refs.mobileSelectedImage;

        if (!imageEl) return;

        imageEl.src = `${image.src}&width=900`;
        imageEl.srcset = this.returnSrcSet(image.src);
        imageEl.alt = image.alt || '';
    });
},

setInitialSelectedImage() {
    if (this.isDesktop) return;

    const images = Alpine.raw(this.currentProduct.media).filter(
        (x) => x.media_type === "image",
    );

    if (!images.length) return;

    let initialImage = undefined;

    if (this.selectedVariant && this.selectedVariant.featured_image) {
        initialImage = images.find(
            (image) => image.id === this.selectedVariant.featured_image.id,
        );
    }

    if (!initialImage) {
        initialImage = images[0];
    }

    this.selectedImage = initialImage;
    this.updateMobileSelectedImage(initialImage);
},

preloadImages(images) {
    if (!this.preloadedImageUrls) {
        this.preloadedImageUrls = {};
    }

    const urls = images
        .filter((image) => image && image.src)
        .map((image) => image.src);

    if (!urls.length) {
        return Promise.resolve();
    }

    return Promise.all(
        urls.map((url) => {
            if (this.preloadedImageUrls[url]) {
                return this.preloadedImageUrls[url];
            }

            this.preloadedImageUrls[url] = new Promise((resolve) => {
                const preloadImage = new Image();

                preloadImage.decoding = "async";

                preloadImage.srcset = this.returnSrcSet(url);
                preloadImage.sizes = this.isDesktop
                    ? "(min-width: 1000px) 33vw"
                    : "25vw";

                preloadImage.onload = resolve;
                preloadImage.onerror = resolve;

                preloadImage.src = url;

                setTimeout(resolve, 2200);
            });

            return this.preloadedImageUrls[url];
        })
    );
},

preloadAllProductImages() {
    // No mobile, não pré-carrega todas as imagens do produto.
    // Isso evita competir com o carregamento do carrossel visível.
    if (!this.isDesktop) return;

    const images = Alpine.raw(this.currentProduct.media).filter(
        (x) => x.media_type === "image",
    );

    images.forEach((image) => {
        if (!image || !image.src) return;

        const preloadImage = new Image();
        preloadImage.decoding = "async";
        preloadImage.src = `${image.src}&width=900`;
    });
},

async loadVariableImages(showLoading = true) {
    if (showLoading) {
        this.isLoading = true;
    }

    const colorName = this.clearString(
        this.selectedVariant.title,
    ).toLowerCase();

    /*
      Se a variante/cor já foi aberta antes,
      usa o cache imediatamente.
      Não força novo preload e não compete com o carregamento mobile.
    */
    if (this.variantImageCache[colorName]) {
        const cachedImages = this.variantImageCache[colorName];

        this.variantImages = cachedImages;
        this.variantHightLightImages = cachedImages.slice(0, 4);
        this.selectedImage = !this.isDesktop
    ? cachedImages[0]
    : undefined;

this.updateMobileSelectedImage(this.selectedImage);

this.active = 0;
this.translateX = 0;
this.isLoading = false;

        return;
    }

    const images = Alpine.raw(this.currentProduct.media).filter(
        (x) => x.media_type === "image",
    );

    if (images.length === 0) {
        this.isLoading = false;
        return;
    }

    const allColorNames = Alpine.raw(this.currentProduct.variants)
        .map((variant) => this.clearString(variant.title).toLowerCase())
        .filter((value, index, self) => value && self.indexOf(value) === index);

    const overlappingColorNames = allColorNames.filter((name) =>
        name !== colorName && name.includes(colorName)
    );

    const nextVariantImages = images.filter((x) => {
        const imageSrc = this.clearString(x.src).toLowerCase();

        const matchesCurrentColor = imageSrc.includes(colorName);

        const matchesAnotherLongerColor = overlappingColorNames.some((name) =>
            imageSrc.includes(name)
        );

        return matchesCurrentColor && !matchesAnotherLongerColor;
    });

    /*
      Salva as imagens da variante no cache.
      Ao retornar para essa cor, o tema reaproveita a lista imediatamente.
    */
    this.variantImageCache[colorName] = nextVariantImages;

    /*
      Atualiza a interface imediatamente, sem aguardar preload.
    */
    this.variantImages = nextVariantImages;
    this.variantHightLightImages = this.variantImages.slice(0, 4);
    this.selectedImage = !this.isDesktop
    ? this.variantImages[0]
    : undefined;

this.updateMobileSelectedImage(this.selectedImage);

this.active = 0;
this.translateX = 0;
this.isLoading = false;

    /*
      Primeira leva: baixa poucas imagens prioritárias.
      No mobile, evita sobrecarga.
    */
    const priorityImages = this.isDesktop
    ? nextVariantImages.slice(0, 2)
    : nextVariantImages.slice(0, 2);

    this.preloadImages(priorityImages);

    /*
      Segunda leva: baixa o restante apenas uma vez por variante,
      em momento ocioso. Isso melhora o retorno para a cor já aberta,
      sem baixar todas as variantes de uma vez.
    */
    if (!this.variantPreloadStarted[colorName]) {
        this.variantPreloadStarted[colorName] = true;

        const remainingImages = this.isDesktop
            ? nextVariantImages.slice(4)
            : nextVariantImages.slice(2);

        if (window.requestIdleCallback) {
            window.requestIdleCallback(() => {
                this.preloadImages(remainingImages);
            });
        } else {
            setTimeout(() => {
                this.preloadImages(remainingImages);
            }, 900);
        }
    }
},
        carousel() {
            console.log("aaa");
        },
        handleSelectImage(img) {
    if (this.isDesktop) return;
    this.selectedImage = img;
    this.updateMobileSelectedImage(img);
},
        expandImage(status) {
            this.openExpandImage = status;
        },
   init() {
    this.selectedVariant = Alpine.raw(
    this.currentProduct.variants,
).find((x) => x.id === variantId);

this.setInitialSelectedImage();

this.loadVariableImages();

this.$nextTick(() => {
    this.updateAuglioVariant();
});

// Aguarda o carregamento principal estabilizar antes de baixar o restante das cores
setTimeout(() => {
    this.preloadAllProductImages();
}, 2500);

// seu init existente continua aqui
this.updatePosition();
            const ro = new ResizeObserver(() => {
                this.isDesktop = window.innerWidth > this.mobileSize;
                this.dragging = false;
                this.updatePosition();
            });
            ro.observe(this.$refs.carousel);
        },
    }));
});

// Reposiciona o botão Auglio dentro da imagem principal após o app movê-lo
(function() {
    function moveAuglioBtn() {
        const btn = document.querySelector('.auglio-tryon-btn-product-page');
        if (!btn) return;

        const isMobile = window.innerWidth <= 999;

        if (isMobile) {
            const target = document.querySelector('.mobile-selected-image');
            if (target && btn.parentNode !== target) {
                target.appendChild(btn);
            }
        } else {
            const target = document.querySelector('.custom-product-images-highlight');
            if (target && btn.parentNode !== target) {
                target.appendChild(btn);
            }
        }
    }

    // Observa mudanças no DOM para capturar quando Auglio move/mostra o botão
    const observer = new MutationObserver(moveAuglioBtn);
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });

    // Também tenta no load e resize
        window.addEventListener('load', moveAuglioBtn);
    window.addEventListener('resize', moveAuglioBtn);
})();
// Ajuste de gesto do carrossel mobile
// Se o gesto for horizontal, evita que a página desça junto.
// Se o gesto for vertical, deixa a página rolar normalmente.

(function () {
    let startX = 0;
    let startY = 0;
    let direction = null;

    function getCarouselFromEvent(event) {
        return event.target.closest('.custom-product-medias .carousel');
    }

    document.addEventListener(
        'touchstart',
        function (event) {
            const carousel = getCarouselFromEvent(event);
            if (!carousel || !event.touches || event.touches.length !== 1) return;

            startX = event.touches[0].clientX;
            startY = event.touches[0].clientY;
            direction = null;
        },
        { passive: true }
    );

    document.addEventListener(
        'touchmove',
        function (event) {
            const carousel = getCarouselFromEvent(event);
            if (!carousel || !event.touches || event.touches.length !== 1) return;

            const currentX = event.touches[0].clientX;
            const currentY = event.touches[0].clientY;

            const diffX = currentX - startX;
            const diffY = currentY - startY;

            const absX = Math.abs(diffX);
            const absY = Math.abs(diffY);

            if (!direction && (absX > 8 || absY > 8)) {
                direction = absX > absY ? 'horizontal' : 'vertical';
            }

            if (direction === 'horizontal' && event.cancelable) {
                event.preventDefault();
            }
        },
        { passive: false }
    );

    document.addEventListener(
        'touchend',
        function () {
            direction = null;
        },
        { passive: true }
    );

    document.addEventListener(
        'touchcancel',
        function () {
            direction = null;
        },
        { passive: true }
    );
})();